import React from 'react';
import cn from 'classnames';
import pluralize from 'pluralize';

import { getDifficultyText } from 'helpers/getDifficultyText';

import { Typography } from 'components/shared/Typography';
import { Icon } from 'components/shared/Icon';

import { Difficulty } from '../Difficulty';

import styles from './CourseInfo.module.scss';

const renderItem = (
  itemType: any,
  {
    withBorder,
    itemClassName,
    iconClassName,
    textClassName,
    lessonsCount,
    studentsCount,
    difficulty,
  }: {
    withBorder: any;
    itemClassName: any;
    iconClassName: any;
    textClassName: any;
    lessonsCount: any;
    studentsCount: any;
    difficulty: any;
  },
) => {
  switch (itemType) {
    case 'LESSONS_COUNT': {
      return (
        <div
          key={itemType}
          className={cn(styles.item, itemClassName, {
            [styles.itemWithBorder]: withBorder,
          })}
        >
          <Icon name="play" className={cn(styles.icon, iconClassName)} />

          <Typography
            variant="body3"
            weight="medium"
            className={cn(styles.text, textClassName)}
          >
            {pluralize('lessons', lessonsCount, true)} left
          </Typography>
        </div>
      );
    }
    case 'DIFFICULTY': {
      return (
        <div
          key={itemType}
          className={cn(styles.item, itemClassName, {
            [styles.itemWithBorder]: withBorder,
          })}
        >
          <Difficulty
            className={cn(styles.difficultyIcon, iconClassName)}
            value={difficulty}
          />
          <Typography
            variant="body3"
            weight="medium"
            className={cn(styles.text, textClassName)}
          >
            {getDifficultyText(difficulty)}
          </Typography>
        </div>
      );
    }
    case 'STUDENTS': {
      return (
        <div
          key={itemType}
          className={cn(styles.item, itemClassName, {
            [styles.itemWithBorder]: withBorder,
          })}
        >
          <Icon name="users" className={cn(styles.icon, iconClassName)} />
          <Typography
            variant="body3"
            weight="medium"
            className={cn(styles.text, textClassName)}
          >
            {studentsCount}
          </Typography>
        </div>
      );
    }
  }
};

const CourseInfo = ({
  className,
  itemClassName,
  iconClassName,
  textClassName,
  withBorder,
  items,
  lessonsCount,
  studentsCount,
  difficulty,
}: {
  className: any;
  itemClassName: any;
  iconClassName: any;
  textClassName: any;
  withBorder: any;
  items: any;
  lessonsCount: any;
  studentsCount: any;
  difficulty: any;
}) => (
  <div className={cn(styles.info, className)}>
    {items.map((item: any) =>
      renderItem(item, {
        withBorder,
        itemClassName,
        iconClassName,
        textClassName,
        lessonsCount,
        studentsCount,
        difficulty,
      }),
    )}
  </div>
);

CourseInfo.defaultProps = {
  items: [],
  withBorder: false,
};

export default React.memo(CourseInfo) as any;
